import apiClient from '../apiClient';
import { handleResponse } from 'src/utils/api-utils';

export const listarConversaciones = () => {
  return handleResponse(apiClient.get('/chat'));
};

export const getMensajes = (operacionId) => {
  return handleResponse(apiClient.get(`/chat/${operacionId}/mensajes`));
};

export const enviarMensaje = (operacionId, mensaje) => {
  return handleResponse(apiClient.post(`/chat/${operacionId}/mensajes`, { mensaje }));
};

export const marcarLeidas = (operacionId) => {
  return handleResponse(apiClient.post(`/chat/${operacionId}/leer`));
};

export const marcarObservada = (operacionId, mensaje) => {
  return handleResponse(apiClient.post(`/chat/${operacionId}/observada`, { mensaje }));
};

export const rechazarPropuesta = (operacionId, mensaje) => {
  return handleResponse(apiClient.post(`/chat/${operacionId}/rechazar`, { mensaje }));
};

export const listarInv = () => {
  return handleResponse(apiClient.get('/chat/inversionista'));
};

export const getInvMensajes = (operacionId, inversionistaId) => {
  return handleResponse(
    apiClient.get(`/chat/inversionista/${operacionId}/${inversionistaId}/mensajes`)
  );
};

export const enviarInv = (operacionId, inversionistaId, mensaje) => {
  return handleResponse(
    apiClient.post(`/chat/inversionista/${operacionId}/${inversionistaId}/mensajes`, { mensaje })
  );
};

export const marcarLeidasInv = (operacionId, inversionistaId) => {
  return handleResponse(
    apiClient.post(`/chat/inversionista/${operacionId}/${inversionistaId}/leer`)
  );
};
